import { render, staticRenderFns } from "./ItemView.vue?vue&type=template&id=bea1e2dc&"
import script from "./ItemView.vue?vue&type=script&lang=js&"
export * from "./ItemView.vue?vue&type=script&lang=js&"
import style0 from "./ItemView.vue?vue&type=style&index=0&id=bea1e2dc&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bea1e2dc')) {
      api.createRecord('bea1e2dc', component.options)
    } else {
      api.reload('bea1e2dc', component.options)
    }
    module.hot.accept("./ItemView.vue?vue&type=template&id=bea1e2dc&", function () {
      api.rerender('bea1e2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ItemView.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/ItemView.vue
// module id = 507
// module chunks = 3